import { Megaphone, Globe, Sparkles, Database, Mail } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
import Reveal from "./Reveal";

const nodeIcons = [Megaphone, Globe, Sparkles, Database, Mail];
const positions = [
  { x: 50, y: 3 },
  { x: 4, y: 44 },
  { x: 96, y: 44 },
  { x: 50, y: 74 },
  { x: 50, y: 97 },
];
const center = { x: 50, y: 44 };
const lines = [
  [center, positions[0]],
  [center, positions[1]],
  [center, positions[2]],
  [center, positions[3]],
  [positions[3], positions[4]],
];

export default function EcosystemGraph() {
  const { t } = useLang();
  const nodes = t("ecosystem.nodes");
  return (
    <section data-testid="ecosystem-section" className="bg-ink2 bg-grid-dark py-20 lg:py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <p className="text-xs font-semibold tracking-[0.25em] text-electric">{t("ecosystem.eyebrow")}</p>
          <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">{t("ecosystem.title")}</h2>
          <p className="mt-4 text-base sm:text-lg text-steel max-w-xl mx-auto leading-relaxed">{t("ecosystem.copy")}</p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="relative mx-auto mt-14 w-full max-w-[520px] aspect-square">
            <svg className="absolute inset-0 h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
              {lines.map(([a, b], i) => (
                <line key={i} x1={a.x} y1={a.y} x2={b.x} y2={b.y} stroke="rgba(33,167,255,0.45)" strokeWidth="0.5" className="flow-dash" vectorEffect="non-scaling-stroke" style={{ strokeDasharray: "4 4" }} />
              ))}
            </svg>
            <div
              className="absolute flex h-28 w-28 sm:h-32 sm:w-32 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-gradient-to-br from-dblue to-electric text-center shadow-[0_0_60px_rgba(20,110,245,0.5)]"
              style={{ left: `${center.x}%`, top: `${center.y}%` }}
            >
              <span className="absolute inset-0 rounded-full border border-electric/40 animate-ping-slow" />
              <p className="font-display text-[10px] sm:text-[11px] font-extrabold tracking-[0.15em] px-3">{t("ecosystem.center")}</p>
            </div>
            {nodes.map((n, i) => {
              const Icon = nodeIcons[i];
              return (
                <div
                  key={n}
                  className="absolute -translate-x-1/2 -translate-y-1/2 flex flex-col items-center gap-2"
                  style={{ left: `${positions[i].x}%`, top: `${positions[i].y}%` }}
                >
                  <div className="flex h-12 w-12 sm:h-14 sm:w-14 items-center justify-center rounded-2xl border border-white/15 bg-ink shadow-lg">
                    <Icon className="h-5 w-5 text-electric" />
                  </div>
                  <p className="text-[9px] sm:text-[10px] font-bold tracking-[0.2em] text-steel">{n}</p>
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
